interface Variables {
  local: Env;
  dev: Env;
  test: Env;
  stage: Env;
  prod: Env;
}
export function setEnvironmentVaribles() {
  const envs = {
    localhost: "local",
    "dev.login.delaval.cloud": "dev",
    "test.login.delaval.cloud": "test",
    "stage.login.delaval.cloud": "stage",
    "login.delaval.com": "prod",
  };

  const variables: Variables = require("./variables.json");
  const usePlusConfig = true;
  // location.href.includes("use-new-cognito=true") ||
  // sessionStorage.getItem("redirect_uri")?.includes("plus");
  const plusVariables = usePlusConfig ? require("./variables-plus.json") : {};
  const foundEnv = Object.entries(envs).find(([url]) =>
    location.href.includes(url)
  );
  if (foundEnv) {
    const key = foundEnv[1] as "local" | "dev" | "test" | "stage" | "prod";
    window.env = {
      ...variables[key],
      ...plusVariables[`${key}`],
    };
    if (plusVariables[`${key}`]?.OAUTHdomain) {
      window.env.OAUTH.domain = plusVariables[`${key}`]?.OAUTHdomain;
    }
    if (usePlusConfig) {
      window.env.OAUTH.responseType = "code";
    }
  }
}
